import ThemeCardV2 from './ThemeCardV2';

export default ThemeCardV2;
